export const SubjectInputs = [
  {
    name: 'name',
    label: "Subject",
    type: 'text',
    defaultValue: '',
    validation: { required: true} }
];